module.exports = {
  title: 'Bézier Curve Outline with React Native Skia',
  author: 'Enzo Manuel Mangano',
  date: '2024-11-05',
  slug: 'bezier-curve-outline',
  tags: ['skia', 'reanimated', 'expo-blur'],
};
